import { createSlice } from '@reduxjs/toolkit';
import * as AllAction from '../action';
import ActionType from '../action/impassableAreaPage';
import {
  makeFetchFailedActionType,
  makeFetchSuccessActionType,
} from '../../event/fetchActionTypeProvider';
const initialState: any = {
  impassableAreaData: {
    total: 0,
    data: [],
    timestamp: 0,
  },
  vehiclePosition: null,
  reloadImpassableListTimeStamp: 0,
};

const handleReloadList = (state: typeof initialState) => {
  state.reloadImpassableListTimeStamp = Date.now();
};
const impassableAreaState = createSlice({
  name: 'impassableArea',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AllAction.actionFetchVehiclePosition, (state, action: any) => {
        const response = action.payload;
        state.vehiclePosition = response.data;
      })
      .addCase(
        makeFetchSuccessActionType(ActionType.IMPASSABLE_AREA_ADD),
        (state, action: any) => {
          handleReloadList(state);
        },
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.IMPASSABLE_AREA_DELETE),
        (state, action: any) => {
          handleReloadList(state);
        },
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.IMPASSABLE_AREA_LIST),
        (state, action: any) => {
          const response = action.payload;
          const { list, pages } = response;
          state.impassableAreaData.total = pages;
          state.impassableAreaData.data = list;
          state.impassableAreaData.timestamp = Date.now();
        },
      )
      .addCase(AllAction.clearImpassableAreaList, (state, action: any) => {
        state.impassableAreaData.total = 0;
        state.impassableAreaData.data = [];
        state.impassableAreaData.timestamp = Date.now();
      });
  },
});

export default impassableAreaState.reducer;
